import React from "react";
import { Card, Badge } from "react-bootstrap";
import moment from "moment";
import { EtfCardProps } from "../Types/types";

export const EtfCard: React.FC<EtfCardProps> = ({ etf, timestamp }) => {
  // Determine badge variant based on decision
  const variant = (d: string) => {
    switch (d.toLowerCase()) {
      case "buy":
        return "success";
      case "sell":
        return "danger";
      default:
        return "warning";
    }
  };

  // Parse as UTC then convert to local for correct "from now"
  const m = moment.utc(timestamp).local();
  const fromNow = m.fromNow();

  return (
    <Card className="h-100 shadow-sm">
      <Card.Body className="d-flex flex-column">
        <Card.Title>{etf.Ticker}</Card.Title>
        <Card.Subtitle className="mb-2 text-muted">
          Decision: <Badge bg={variant(etf.Decision)}>{etf.Decision}</Badge>
        </Card.Subtitle>
        <Card.Text className="flex-grow-1">{etf.Explanation}</Card.Text>
        <div className="mt-3 text-end">
          <small className="text-muted">{fromNow}</small>
        </div>
      </Card.Body>
    </Card>
  );
};
